module.exports = __webpack_public_path__ + "img/pro_four_4.5bbe9256.jpg";